import React, { useEffect, useState } from 'react';
import { taskAPI } from '../services/api';

const columns = ['To Do', 'In Progress', 'Done'];

const KanbanBoard = ({ tasks: propTasks = null, onLogout }) => {
  const [tasks, setTasks] = useState(propTasks || []);
  const [loading, setLoading] = useState(!propTasks);
  const [error, setError] = useState('');

  // 🔧 FIX: Only fetch if no tasks provided as props (standalone usage)
  useEffect(() => {
    if (!propTasks) {
      // This is standalone usage (from /kanban route)
      const fetchTasks = async () => {
        try {
          setLoading(true);
          setError('');
          const response = await taskAPI.getTasks();
          setTasks(response.data);
        } catch (err) {
          console.error('Failed to fetch tasks for KanbanBoard:', err);
          setError('Failed to load tasks');
          if (err.response?.status === 401 && onLogout) {
            onLogout();
          }
        } finally {
          setLoading(false);
        }
      };

      fetchTasks();
    }
  }, [propTasks, onLogout]);

  // 🔧 FIX: Update local state when props change
  useEffect(() => {
    if (propTasks) {
      setTasks(propTasks);
      setLoading(false);
    }
  }, [propTasks]);

  const getTasksByStatus = (status) => {
    return tasks.filter(task => task.status === status);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-gray-600">Loading tasks...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-4">
      {columns.map((col) => (
        <div key={col} className="bg-gray-100 p-4 rounded shadow-md">
          <h2 className="text-lg font-bold mb-2">{col}</h2>
          {getTasksByStatus(col).map(task => (
            <div key={task.id} className="bg-white p-3 mb-2 rounded shadow">
              <h3 className="font-semibold">{task.title}</h3>
              <p className="text-sm">{task.description}</p>
              <p className="text-xs text-gray-500">
                Assignees: {task.assignees?.map(a => a.username).join(', ') || 'None'}
              </p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default KanbanBoard;
